import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from './firestore.service';
import type { TAccount, TAccountTOC } from '@shared/models';

@Injectable({
    providedIn: 'root'
})
export class AccountsService {
    private myListener: any = null;

    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public unsubscribeListener() {
        if (this.myListener) {
            this.myListener();
        }

        // this.firestoreService.unsubscribeListener(this.myListener);
        this.myListener = null;
    }

    public getObservable(): Observable<TAccount[]> {
        const path = this.firestorePathsService.getAccountsPath();
        const observable = this.firestoreService.getObservable(path) as Observable<TAccount[]>;
        return observable;
    }

    // I don't think anyone is calling this.
    // public subscribeChangeListener(callback: (snapshot: DocumentData) => void) {
    //     const collectionPath = this.firestorePathsService.getAccountsPath();
    //     this.firestorePathsService.subscribeChangeListener(collectionPath, callback);
    // }

    // public getTableOfContents(): Promise<any> {
    public async getTableOfContents(): Promise<TAccountTOC> {
        const path = this.firestorePathsService.getAccountsPath();
        const response = await this.firestoreService.getByUid(path, 'tableOfContents');
        return response as TAccountTOC;
    }

    public async getByUid(uid: string): Promise<TAccount> {
        const path = this.firestorePathsService.getAccountsPath();
        const response = await this.firestoreService.getByUid(path, uid);
        return response as TAccount;
    }

    public async getAll(): Promise<TAccount[]> {
        const path = this.firestorePathsService.getAccountsPath();
        const response = await this.firestoreService.getAll(path);
        return response as TAccount[];
    }

    public async add(acct: TAccount): Promise<TAccount> {
        const path = this.firestorePathsService.getAccountsPath();
        const response = await this.firestoreService.add(path, acct);
        return response as TAccount;
    }

    public async set(acct: TAccount, uid: string): Promise<TAccount> {
        acct.uid = uid;
        const path = this.firestorePathsService.getAccountsPath();
        const response = await this.firestoreService.set(path, acct);
        return response as TAccount;
    }

    public async update(map: TAccount): Promise<TAccount> {
        const path = this.firestorePathsService.getAccountsPath();
        const response = await this.firestoreService.update(path, map);
        return response as TAccount;
    }

    public delete(uid: string): Promise<void> {
        const path = this.firestorePathsService.getAccountsPath();
        return this.firestoreService.delete(path, uid);
    }
}
